import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn, TableFooter } from 'material-ui/Table';
import React, { PropTypes, Component } from 'react';
import SortIcon from 'material-ui/svg-icons/action/swap-vert';
import IconButton from 'material-ui/IconButton';
import ChevronLeft from 'material-ui/svg-icons/navigation/chevron-left';
import ChevronRight from 'material-ui/svg-icons/navigation/chevron-right';
import TableSpinner from './TableSpinner';
import formatTableCell from './formatTableCell';

const Styles ={
  table: {
    paddingTop: 30
  },
  rowAlign: {
    display: 'flex',
    alignItems: 'center'
  },
  footerControls: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  },
  sortIcon: {
    cursor: 'pointer',
    path: {
      fill: 'rgb(255, 255, 255) !important',
      pointerEvents: 'none'
    }
  }
}

function sortFunc(a, b, sortHeader) {
  var key = sortHeader.dataAlias;

  if (typeof (a[key]) === 'number') {
    return a[key] - b[key];
  }
  else if(typeof (a[key]) === 'boolean'){
    return a[key] - b[key];
  }

  var valueA = '';  
  var valueB = '';
  if(sortHeader.format.type === 'relation'){
    valueA = ((a[key] && a[key][sortHeader.format.displayColumn]) ? a[key][sortHeader.format.displayColumn] : '');
    valueB = ((b[key] && b[key][sortHeader.format.displayColumn]) ? b[key][sortHeader.format.displayColumn] : '');    
  }
  else{
    valueA = (a[key] ? a[key] : '');
    valueB = (b[key] ? b[key] : '');
  }

  var result = valueA.localeCompare(valueB);
  if(result === 0)
    return a.ID - b.ID;
  else    
    return result;
}

function processTableData(data) {
  if (data.constructor === Array) {
    return data.map((obj) => {
      const newObj = {};

      Object.keys(obj).forEach(key => {
        if (typeof obj[key] === 'object' && obj[key]) {
          Object.keys(obj[key]).forEach(subKey => {            
            newObj[subKey] = obj[key][subKey];
          });
        } else {
          newObj[key] = obj[key];
        }
      });

      return newObj;
    });
  }
  return [];
}  

class SmartTable extends Component {
  constructor(props) {
    super(props);    

    this.onRowSelected = this.onRowSelected.bind(this);

    this.state = {
      isAsc: true,
      sortHeader: null,
      offset: 0,
      limit: props.limit,
      pageContent: [],
      defaultOrderLoaded: false
    }; 
  }

  componentWillMount() {    
    this.setState({
      data: this.props.data,
      pageContent: this.props.data ? this.props.data.slice(this.state.offset, this.props.limit) : [],
    });    
  }

  componentWillReceiveProps(nextProps) {
    var defaultColumnName = nextProps.defaultOrderBy;    

    if(defaultColumnName && !this.state.defaultOrderLoaded && nextProps.data.length > 0){
      var asc = this.state.isAsc;
      if(defaultColumnName.indexOf('-') === 0){
        asc = false;
        defaultColumnName = defaultColumnName.substring(1, defaultColumnName.length);
      }
      else
        asc = true;

      var sortHeader = nextProps.tableHeaders.find((x) => x.dataAlias === defaultColumnName);
      this.sortByColumnDirection(sortHeader, nextProps.data, nextProps.limit, asc);
      this.setState({defaultOrderLoaded: true});          
    }

    this.setState({
      offset: this.state.offset,
      sortHeader: null,
      data: nextProps.data,
      pageContent: nextProps.data ? nextProps.data.slice(this.state.offset, this.state.offset + nextProps.limit) : [],
    });
  }

  sortByColumn(sortHeader, data, limit) {
    const isAsc = this.state.sortHeader === sortHeader ? !this.state.isAsc : true;
    this.sortByColumnDirection(sortHeader, data, limit, isAsc);
  }

  sortByColumnDirection(sortHeader, data, limit, isAsc) {    
    const sortedData = data.sort((a, b) => sortFunc(a, b, sortHeader));
    if (!isAsc) {
      sortedData.reverse();
    }

    this.setState({
      pageContent: sortedData.slice(0, limit),
      data: sortedData,
      sortHeader,
      offset: 0,
      isAsc
    });
  }

  paginate(offset, limit) {
    this.setState({
      pageContent: this.state.data.slice(offset, offset + limit),
      offset,
    });
  }

  onRowSelected(entityIndex){
    if(this.props.onEntitySelection)
      this.props.onEntitySelection(this.state.pageContent[entityIndex]);  
  }

  render() {           
    const { total, tableHeaders, isLoading } = this.props;
    const { offset, limit, pageContent } = this.state;

    const processedData = pageContent;

    var allowSelection = (this.props.allowSelection ? true : false);

    return (
      <Table onRowSelection={this.onRowSelected} style={ Styles.table } selectable={allowSelection}>
        <TableHeader displaySelectAll={ false } adjustForCheckbox={allowSelection}>
          <TableRow>
            { !!tableHeaders && tableHeaders.map((header, index) => (              
              <TableHeaderColumn key={ index } style={header.style}>
                <div style={ Styles.rowAlign }>                
                  { header.alias }
                  { header.sortable &&
                    <IconButton id={ header.dataAlias } onClick={ (e) => this.sortByColumn(header, this.state.data, limit) }>
                      <SortIcon
                        style={ Styles.sortIcon }
                      />
                    </IconButton>
                  }
                </div>
              </TableHeaderColumn>
            )) }
          </TableRow>
        </TableHeader>
        <TableBody deselectOnClickaway={false} showRowHover={false} displayRowCheckbox={allowSelection} preScanRows>
          {
            (isLoading && <TableSpinner />) ||
            (processedData.map((row, index) => (
              <TableRow key={ index } style={{verticalAlign: 'middle'}}>
                { tableHeaders.map((header, propIndex) => (
                  <TableRowColumn key={ propIndex } style={header.style}>{ formatTableCell(header.dataAlias, row[header.dataAlias], header.format, row, this.props.updateEntityCallBack) }</TableRowColumn>
                )) }
              </TableRow>
            )))
          }
        </TableBody>
        <TableFooter>
          <TableRow>
            <TableRowColumn>
              <div style={ Styles.footerControls }>
                { `${Math.min((offset + 1), total)} - ${Math.min((offset + limit), total)} sur ${total}` }
                <IconButton disabled={ offset === 0 } onClick={ () => this.paginate(offset - limit, limit) }>
                  <ChevronLeft />
                </IconButton>
                <IconButton disabled={ offset + limit >= total } onClick={ () => this.paginate(offset + limit, limit) }>
                  <ChevronRight />
                </IconButton>
              </div>
            </TableRowColumn>
          </TableRow>
        </TableFooter>
      </Table>
    );
  }
}

SmartTable.propTypes = {
  tableHeaders: PropTypes.array,
  data: PropTypes.array,
  offset: PropTypes.number, // current offset
  total: PropTypes.number, // total number of rows
  limit: PropTypes.number, // num of rows in each page,
  isLoading: PropTypes.bool,
  allowSelection: PropTypes.bool,
  defaultOrderBy: PropTypes.string,
};

export default SmartTable;



/** WEBPACK FOOTER **
 ** ./src/app/components/SmartTable/SmartTable.js
 **/